<template>
    <crm-content>
        <template v-slot:actionLeft>
            <vx-action-icon icon="MenuIcon" class="mr-4" @click="toggleSideBar" />
            <h4>{{ title }}</h4>
        </template>
        <template v-slot:actionRight>
            <vx-action-icon
                isButton
                color="primary"
                icon="PlusIcon"
                tooltip="Create New User"
                @click="openNew"
            ></vx-action-icon>
        </template>
        <user-table />
    </crm-content>
</template>

<script>
import UserTable from './UserTable.vue'
import CrmContent from '../../crm/components/CrmContent.vue'

export default {
    name: 'user-main',
    components: {
        CrmContent,
        UserTable
    },
    data() {
        return {
            title: 'Users'
        }
    },
    methods: {
        openNew() {
            this.$router.push({ name: 'user-details' })
        }
    }
}
</script>
